export default {
	avatarCropper: {
		title: 'Kép körülvágása',
	},
	avatarUploadField: {
		previewAlt: 'Avatar előnézet',
	},
};
